import { render } from "./Product.vue?vue&type=template&id=3cf4ef6f&scoped=true"
import script from "./Product.vue?vue&type=script&lang=js"
export * from "./Product.vue?vue&type=script&lang=js"

import "./Product.vue?vue&type=style&index=0&id=3cf4ef6f&scoped=true&lang=scss"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cf4ef6f"],['__file',"src/components/Product.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3cf4ef6f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3cf4ef6f', __exports__)) {
    console.log('reload')
    api.reload('3cf4ef6f', __exports__)
  }
  
  module.hot.accept("./Product.vue?vue&type=template&id=3cf4ef6f&scoped=true", () => {
    console.log('re-render')
    api.rerender('3cf4ef6f', render)
  })

}


export default __exports__